module.exports = __webpack_public_path__ + "static/media/simpals_grey.d382efcc.svg";